import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { SchoolService } from "../../../../../../shared/services/school.service";

@Component({
	selector: "app-user-modify-add-school",
	templateUrl: "./user-modify-add-school.component.html",
	styleUrls: ["./user-modify-add-school.component.css"],
})
export class UserModifyAddSchoolComponent implements OnInit {
	constructor(private ref: DynamicDialogRef, private schoolService: SchoolService, private dialogConfig: DynamicDialogConfig) {}

	ngOnInit(): void {
		//Get Data from DB
		this.loadSchoolist();
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////

	lstSchool: any = [];
	SelectedSchools: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	cols = [
		{ field: "SchoolNumber", header: "School Number" },
		{ field: "SchoolName", header: "School Name" },
	];

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////
	private loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				var Selected: any = this.dialogConfig.data.SelectedSchools;
				var Data: any = response;

				for (var z = 0; z < Data.length; z++) {
					var next = Data[z];

					var found = false;
					for (var x = 0; x < Selected.length; x++) {
						var select = Selected[x];

						if (next.SchoolID == select.SchoolID) {
							found = true;
						}
					}

					if (!found) {
						this.lstSchool = [...this.lstSchool, next];
					}
				}

				// this.lstSchool = response;
				// this.UpdateSelected();
			},
			(error) => {}
		);
	}

	// UpdateSelected(){
	//   var FromMain: any = this.dialogConfig.data.SelectedSchools;

	//   console.log("Selected Schools");
	//   console.log(FromMain);

	//   console.log(FromMain.indexOf(this.lstSchool[0]));

	//   this.lstSchool = this.lstSchool.filter(school => FromMain.indexOf(school) == -1); //? Not working?
	//   console.log(this.lstSchool);
	// }
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onSelectAll() {}
	onUnselectAll() {}
	onUpdate() {
		this.ref.close(this.SelectedSchools);
	}
	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	///////////////////////////////////////////////////////
}
